<template>
  <div class="all-wrap">
    <div class="tabs">
      <div class="tab-item-active myAsk"
           @click="changeTab('getWordSub')">我的学习</div>
    </div>
    <div class="all-content">
      <el-table
        :data="dataList"
        border
        v-loading="dataListLoading"
        class="customer-table"
        row-key="id"
      >
        <el-table-column
          align="center"
          label="序号"
          width="50"
          type="index"
        >
          <template slot-scope="{row}">
            {{indexMethod(row)}}
          </template>
        </el-table-column>
        <el-table-column
          :formatter="dateFormat"
          label="课程名称"
        ></el-table-column>
        <el-table-column
          prop="chapterName"
          header-align="center"
          align="center"
          :formatter="chapterName"
          label="章节名称"
        >
          <template slot-scope="{row}"  v-if="!row.index">
            {{chapterName(row)}}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="userName"
                         header-align="center"
                         align="center"
                         label="姓名"></el-table-column> -->
        <el-table-column
          prop="chapterDuringTime"
          header-align="center"
          align="center"
          label="总时长"
        ></el-table-column>
        <el-table-column
          prop="teacherName"
          header-align="center"
          align="center"
          label="讲师名称"
        ></el-table-column>
        <!-- <el-table-column
          prop="createTime"
          header-align="center"
          align="center"
          label="观看时间"
        ></el-table-column> -->
        <el-table-column
          prop="viewingTime"
          header-align="center"
          align="center"
          label="学习时长"
        ></el-table-column>
        <!-- toDetail -->
        <el-table-column
          prop="viewingTime"
          header-align="center"
          align="center"
          label="操作"
        >
        <template slot-scope="{row}">
          <el-button type='text' @click="toDetail(row)">继续观看</el-button>
        </template>
        </el-table-column>
        <!-- <el-table-column prop="playerCount" header-align="center" align="center" label="观看次数"></el-table-column> -->
      </el-table>
    </div>
    <!-- 分页 -->
    <!-- <div
      class="doclist-pagination"
      v-if="dataList === [] || dataList.length !== 0"
    >
      <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
      <div class="doclist-omit">{{ lastOmit }}</div>
      <ul>
        <li
          :class="item === currentPage ? 'pageactive' : ''"
          v-for="(item, index) in pageList"
          :key="index"
          @click="getDataList(item)"
        >
          {{ item }}
        </li>
      </ul>
      <div class="doclist-omit">{{ nextOmit }}</div>
      <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
      <div class="doclist-pagejump">
        共{{ totalPage }}页，到第
        <input type="text" v-model.number="jumpTargetPage" />页
      </div>
      <div class="doclist-jump" @click="jumpFarPage">确定</div>
    </div> -->
  </div>
</template>
<script>
export default {
  data () {
    return {
      dataForm: {
        name: ''
      },
      dataListLoading: false,
      dataList: [],
      totalPage: 0,
      pageSize: 10,
      currentPage: 1,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1
    }
  },
  // filters: {
  //   wordProcessing (dataList) {
  //     return dataList.courseName.slice(0, 1)
  //     // ${name.slice(0,10)}<br/>${name.slice(0,8)}…
  //   }
  // },
  filters: {

  },
  mounted () {
    this.getDataList()
  },
  methods: {
    indexMethod (data) {
      return data.index || ''
    },
    // 跳转到详情
    toDetail (val) {
      this.$router.push({
        path: '/courseDetail',
        query: {
          id: val.courseId,
          chapterId: val.chapterId
        },
        params: {
          chapterId: val.chapterId
        }
      })
    },
    getDataList (currentPage = this.currentPage) {
      // console.log(this.$store.state.user)
      this.dataListLoading = true
      this.$request
        .postParam(
          `/help/train/trainCourseStudyhistory/v2/list`,
          {
            // page: currentPage,
            // limit: this.pageSize,
            userId: this.$store.state.user.id
            // "name" : this.dataForm.name
            // "name" :this.$store.state.user.username
          }
        )
        .then(data => {
          //   console.log(data)
          // if (data.data.code === 0) {
          //   console.log(data.data.data.data)
          if (!data) {
            this.dataList = []
            return false
          }
          data.forEach((item, index) => {
            item.id = item.courseId
            item.index = index + 1
          })
          this.dataList = data || []
          // this.totalPage = data.data.data.count
          // 分页
          // this.totalPage = Math.ceil(data.data.data.count / 10)
          // this.changePageTo(currentPage)
          // }
        })
        .catch(() => {
          this.dataList = []
        })
        .finally(() => {
          this.dataListLoading = false
        })
      // this.jumpTargetPage = 1
    },
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.getDataList(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.getDataList(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    changePageTo (page) {
      //   window.scrollTo(0, 0);
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
      //   this.getDataList()
    },
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (
            this.jumpTargetPage > 2 &&
            this.jumpTargetPage < this.totalPage - 4
          ) {
            var newPageList3 = []
            for (
              let index = this.jumpTargetPage - 2;
              index < this.jumpTargetPage + 3;
              index++
            ) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [
              this.totalPage - 4,
              this.totalPage - 3,
              this.totalPage - 2,
              this.totalPage - 1,
              this.totalPage
            ]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.getDataList()
        window.scrollTo(0, 0)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    // // 导出
    // exportHandle(){
    //   var params = {
    //       token: Cookies.get("access_token"),
    //       name :  this.dataForm.name
    //     };
    //     window.location.href = `${window.SITE_CONFIG["trainURL"]}/courseManagement/traincoursestudyhistory/export?${qs.stringify(params)}`;
    //     // window.location.href = `${window.SITE_CONFIG['trainURL']}/courseManagement/traincoursestudyhistory/export?name=${this.dataForm.name}`
    // }
    dateFormat (dataList) {
      let firstLine = dataList.courseName.slice(0, 10)
      let secondLine = dataList.courseName.slice(10, 18)
      if (dataList.courseName.length > 19) {
        return firstLine + '\n' + dataList.courseName.slice(10, 18) + '...'
      } else {
        return firstLine + '\n' + secondLine
      }
    },
    // 章节名称处理
    chapterName (dataList) {
      let firstLine = dataList.chapterName.slice(0, 10)
      let secondLine = dataList.chapterName.slice(10, 18)
      if (dataList.chapterName.length > 19) {
        return firstLine + '\n' + dataList.chapterName.slice(10, 18) + '...'
      } else {
        return firstLine + '\n' + secondLine
      }
    }
  }
}
</script>
<style>
.all-content {
  margin: 0 69px;
  margin-bottom: 10px;
}
.myAsk {
  width: 100px;
  text-align: center;
}
.search-but {
  width: 400px;
  min-width: 200px;
  text-align: right;
  float: left;
}
.info-but {
  background: #ffffff;
  width: 96px;
  height: 40px;
  text-align: center;
  line-height: 38px;
  font-size: 14px;
  color: #1d65a8;
  letter-spacing: 0;
  border: none;
  cursor: pointer;
  user-select: none;
  border: 1px solid #1d65a8;
  margin-right: 10px;
}
.info-but:hover {
  background: #1d65a8;
  color: #ffffff;
}
.search-name {
  float: left;
  width: 400px;
}
.customer-table th {
  border: none;
}
.customer-table .el-table__row td {
  border-bottom: 1px solid #ccc;
}
.customer-table td,
.customer-table th.is-leaf {
  border: none;
}
.el-table--border,
.el-table--group {
  border: none;
}
.customer-table thead tr th.is-leaf {
  border: 1px solid #ebeef5;
  border-right: none;
}
.customer-table thead tr th:nth-last-of-type(2) {
  border-right: 1px solid #ebeef5;
}
.el-table--border::after,
.el-table--group::after {
  width: 0;
}
.customer-table::before {
  width: 0;
}
.customer-table .el-table__fixed-right::before,
.el-table__fixed::before {
  width: 0;
}
.el-table .cell {
white-space: pre-line;
}
</style>
